import { useState } from 'react';
import { useFaqItems } from '@/hooks/useFaqItems';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

export default function HomeFaqV2() {
  const items = useFaqItems();
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  if (!items.length) return null;

  return (
    <section className="bg-paper py-24 md:py-32">
      <div className="mx-auto max-w-4xl px-6 md:px-8">
        <div className="text-center">
          <SectionLabel className="justify-center">Les vraies questions</SectionLabel>
          <h2 className="mt-6 font-marketing-display text-[clamp(32px,4.2vw,54px)] font-bold leading-[1] tracking-[-0.035em] text-charcoal-800">
            Ce que <span className="underline-lime">tu veux savoir</span> avant de te lancer.
          </h2>
        </div>

        <ul className="mt-14 space-y-4">
          {items.map((item, idx) => {
            const isOpen = openIdx === idx;
            return (
              <li key={item.q} className="border-2 border-charcoal-800 bg-white shadow-neobrutal-4">
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpenIdx(isOpen ? null : idx)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-marketing-display text-[17px] font-bold text-charcoal-800 md:text-lg cursor-pointer"
                >
                  <span>{item.q}</span>
                  <span
                    className={`flex h-8 w-8 flex-shrink-0 items-center justify-center border-2 border-charcoal-800 ${
                      isOpen ? 'bg-lime-500' : 'bg-paper'
                    } transition-colors`}
                    aria-hidden="true"
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.6"
                      className={`transition-transform ${isOpen ? 'rotate-45' : ''}`}
                    >
                      <path d="M7 2v10" />
                      <path d="M2 7h10" />
                    </svg>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t-2 border-charcoal-800 bg-paper px-6 py-5 font-marketing-body text-[15px] leading-relaxed text-charcoal-700 md:text-base">
                    {item.a}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
